module.exports = __webpack_public_path__ + "static/media/cross-white.ae57a7ce.svg";